import React, { useEffect, useState } from 'react'
import Autosuggest from 'react-autosuggest'
import { useSuggestions } from '../../../../../../../../Packages/Plugins/TechDivision.SearchPlugin/Resources/Private/JavaScript/Hooks/useSuggestions'
import { SearchPhraseSuggestions } from './components/SearchPhraseSuggestions'

const theme = {
    container: 'suggest__container',
    containerOpen: 'suggest__container--open',
    input: 'suggest__input',
    inputOpen: 'suggest__input--open',
    inputFocused: 'suggest__input--focused',
    suggestionsContainer: 'suggest__suggestions-container',
    suggestionsContainerOpen: 'suggest__suggestions-container--open',
    suggestionsList: 'suggest__suggestions-list',
    suggestion: 'suggest__suggestion',
    suggestionFirst: 'suggest__suggestion--first',
    suggestionHighlighted: 'suggest__suggestion--highlighted',
    sectionContainer: 'suggest__section-container',
    sectionContainerFirst: 'suggest__section-container--first',
    sectionTitle: 'suggest__section-title',
}

/**
 * Suggest
 * Autosuggest https://github.com/moroshko/react-autosuggest#installation
 * @param config
 * @param eventDispatcher
 * @returns {JSX.Element}
 * @constructor
 */
export function Suggest({ config }) {
    const [suggestions, setSuggestions] = useState([])
    const [fieldValue, setFieldValue] = useState(config.queryParam.length ? config.queryParam : '')
    const [userInputFieldValue, setUserInputFieldValue] = useState(config.queryParam.length ? config.queryParam : '')
    const apiUrl = config.suggestUrl ? config.suggestUrl : config.apiUrl
    const { fetchSuggestions } = useSuggestions(apiUrl)
    const getSuggestionValue = (suggestion) => suggestion
    const renderSuggestion = (suggestion) => <div>{suggestion}</div>

    const handleSubmit = (event, { suggestionValue: value } = {}) => {
        event.preventDefault()
        const searchValue = value !== undefined ? value : fieldValue
        const target = `${config.searchPage}${encodeURIComponent(searchValue)}`
        window.open(target, '_self')
    }

    useEffect(() => {
        const customEvent = new CustomEvent('suggestIsLoaded', {})
        document.dispatchEvent(customEvent)
    })

    const onChange = (e, { newValue }) => {
        setUserInputFieldValue(newValue)
        setFieldValue(newValue)
    }

    const onSuggestionsFetchRequested = async ({ value }) => {
        const apiData = await fetchSuggestions(value)
        setSuggestions(apiData.completions)
    }

    const handleHighlight = (highlight) => {
        if (highlight.suggestion != null) {
            setFieldValue(highlight.suggestion)
        } else {
            setFieldValue(userInputFieldValue)
        }
    }

    const inputProps = {
        placeholder: config?.labelPlaceholder ? config?.labelPlaceholder : '',
        value: fieldValue,
        onChange: onChange,
    }

    const iconClickHandler = () => {
        setFieldValue(config.queryParam.length ? config.queryParam : '')
    }

    const renderInputComponent = (inputProps) => (
        <div className="suggest_wrapper">
            <input {...inputProps} />
            <span onClick={iconClickHandler} className="suggest__search-icon"></span>
        </div>
    )

    return (
        <form onSubmit={handleSubmit} className="suggest__form">
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={() => {
                    setSuggestions([])
                }}
                getSuggestionValue={getSuggestionValue}
                onSuggestionSelected={handleSubmit}
                onSuggestionHighlighted={handleHighlight}
                renderSuggestion={renderSuggestion}
                renderInputComponent={renderInputComponent}
                inputProps={inputProps}
                theme={theme}
            />
            <button className="suggest__submit" type="submit">
                {config?.labelSubmit ? config?.labelSubmit : ''}
            </button>
            {config?.searchSuggestions ? (
                <SearchPhraseSuggestions searchSuggestions={config?.searchSuggestions} basePath={config.searchPage} />
            ) : null}
        </form>
    )
}
